module.exports = __webpack_public_path__ + "static/media/Post Street, San Francisco, CA5.32866dc4.jpg";